import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RecebiveisPaged, Receivables } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class ReceivableTypeService {
  private readonly API = `${environment.api_url}/TipoRecebivel`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<Receivables[]> {
    return this.http.get<Receivables[]>(`${this.API}`);
  }

  getAllPaged(filter): Observable<RecebiveisPaged> {
    return this.http.get<RecebiveisPaged>(`${this.API}/GetAllRecebiveisPaged`, {
      params: filter
    });
  }

  create(body: Receivables): Observable<void> {
    return this.http.post<void>(`${this.API}`, body);
  }

  update(body: Receivables): Observable<void> {
    return this.http.put<void>(`${this.API}/${body.id}`, body);
  }

  getById(id: string): Observable<Receivables> {  
    return this.http.get<Receivables>(`${this.API}/${id}`);
  }
}
